import React from 'react';
import { FormattedMessage } from 'react-intl';

export default [
    {
        trackingLabel: 'Copyright',
        dataTn: 'footer-copyright',
        formattedMessage: (
            <FormattedMessage
                id="dbl.Footer.legal_links_copyright"
                defaultMessage={`© 1stdibs, Inc. {year}`}
                values={{ year: new Date().getFullYear() }}
            />
        ),
    },
    {
        trackingLabel: 'User Agreement',
        href: '/about/user-agreement/',
        target: '_blank',
        dataTn: 'footer-agreement',
        formattedMessage: (
            <FormattedMessage
                id="dbl.Footer.legal_links_agreement"
                defaultMessage="User Agreement"
            />
        ),
    },
    {
        trackingLabel: 'Privacy Policy',
        href: '/about/privacy-policy/',
        target: '_blank',
        dataTn: 'footer-privacy',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.legal_links_privacy" defaultMessage="Privacy Policy" />
        ),
    },
];



// WEBPACK FOOTER //
// ./src/components/Footer/messages/legalLinks.jsx